import dayjs from 'dayjs'
import I18n from 'i18n-js'
import { isCoordinator } from '../../../../router/permissions'
import medicalsCenter from '../../../../services/medicalsCenter'
import { downloadZip } from '../../../../utils/tools'

// Generates and downloads the statistic report ZIP using the modal controller's data.
// Coordinators use their own endpoint. Returns true on success (the modal is closed).
export const generateStatisticReport = async (controller, state) => {
  controller.setLoading(true)
  const body = {
    medical_center_ids: controller.data?.selected,
    from_date: dayjs(controller.data.start).format('YYYY-MM-DD'),
    to_date: dayjs(controller.data.end || new Date()).format('YYYY-MM-DD'),
  }

  const getReport = isCoordinator(state)
    ? medicalsCenter.getCoordinatorIndicators
    : medicalsCenter.getIndicators
  const response = await getReport(body)
  const success = Boolean(response.data)
  if (success) {
    downloadZip(response.data, `${I18n.t('general.report')}.zip`)
    controller.handleClose()
  }
  controller.setLoading(false)
  return success
}
